import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { receiveError } from '../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../api/pickupOrderRemote';

import GhaDashboard from './GhaDashboard';

import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import OrderDashboard from '../../../models/OrderDashboard';
import environments from '../../../configs/environments';
import ghaDashboardStyles from './ghaDashboard.module.css';

import queueRemote from '../../../api/queueRemote';
import DriverQueue, { DriverQueueState, ResultDriverQueue } from '../../../models/DriverQueue';
import { baseUrl } from '../../../api/baseUrl';
import { headers } from '../../../api/headers';
import User from '../../../models/User';
import Counter from '../../../models/Counter';
import { setAirlinesAction } from '../../../store/actions/countersAction';
import GhaModel from '../../../models/Gha';

interface GhaDashboardContainerProps {
  receiveError: Function;
  user: User;
  driverQueueState: DriverQueueState;
  counters: Array<Counter>;
  dashboardCounters: Array<any>;
  setCounters: (counters: any[]) => void;
  gha: GhaModel;
};
  
interface GhaDashboardContainerState {
  pos: Array<OrderDashboard>;
  completed: boolean;
  dropOff: boolean;
  pickups: boolean;
  queue: Array<DriverQueue>;
  serving: Array<DriverQueue>;
  waitTime: number;
  counterData: Array<string>;
  gha: GhaModel;
};

let height = 0;
let i = 1;
let j = 1;

class GhaDashboardContainer extends Component<GhaDashboardContainerProps, GhaDashboardContainerState> {

  intervalID: number | undefined;

  state = {
    pos: [],
    completed: true,
    dropOff: true,
    pickups: true,
    queue: [],
    serving: [],
    waitTime: 0,
    counterData: [''],
    gha: {} as GhaModel
  }

  componentDidMount() {
    const value = localStorage.getItem('gha');
    if(value) {
      const gha = JSON.parse(value);
      this.setState({ gha }, () => {
        height = this.getWindowDimensions();
        this.toggleShowDashboard();
        this.intervalID = window.setInterval(
          () => {
            this.toggleShowDashboard();
          },
          environments.refreshInterval
        );
      });
    }

  }
  

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  componentDidUpdate(prevProps: GhaDashboardContainerProps) {
    if(prevProps.driverQueueState.queue !== this.props.driverQueueState.queue) {
      const value = localStorage.getItem('gha');
      if(value) {
        const gha = JSON.parse(value);
        this.setState({ gha }, () => {
          this.toggleShowDashboard()
        });
      }
    }
  }

  filterBasedOnAirlines = () => {

  }


  paginate = (queue: Array<DriverQueue>, page_size: number, page_number: number): DriverQueue[] => {
    // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
    return queue.slice((page_number - 1) * page_size, page_number * page_size);
  }

  toggleShowDashboard = (): void => {
    let count = 13;
    let servingCount = 4;
    if(height <= 1200) {
      count = 10;
    } else if(height > 1500) {
      count = 15;
      servingCount = 5;
    }
    const filteredQueue = this.props.driverQueueState.queue.filter(item => {
      const hasAirlines = this.state.gha.info.counter_filtering && this.state.gha.info.counter_filtering == 'airline';
      const hasType = this.state.gha.info.counter_filtering && this.state.gha.info.counter_filtering == 'type';
    
      if (hasAirlines && item.info.airlines) {
        return item.info.airlines.some(airline => this.state.counterData.includes(airline));
      } else if (hasType && item.info.type) {
        return this.state.counterData.some(data => data === item.info.type);
      }
    
      return true;
    }); 
  
    const filteredServing = this.props.driverQueueState.serving.filter(item => {
      const hasAirlines = this.state.gha.info.counter_filtering && this.state.gha.info.counter_filtering == 'airline';
      const hasType = this.state.gha.info.counter_filtering && this.state.gha.info.counter_filtering == 'type';
    
      if (hasAirlines && item.info.airlines) {
        return item.info.airlines.some(airline => this.state.counterData.includes(airline));
      } else if (hasType && item.info.type) {
        return this.state.counterData.some(data => data === item.info.type);
      }
    
      return true;
    });
    const pages = Math.ceil(filteredQueue.length / count);
    const servingPages = Math.ceil(filteredServing.length / servingCount);
    if(i > pages) {
      i = 1;
    }
    if(j > servingPages) {
      j = 1;
    }
    const newQueue = this.paginate(filteredQueue, count, i);
    const newServingList = this.paginate(filteredServing, servingCount, j);
    i++;
    j++;
    this.setState({ queue: newQueue, serving: newServingList });
  }

  loadPickupOrders = ():void => {
    const currentDate: string = moment().format('YYYYMMDD');

    pickupOrderRemote.getPickupOrdersGha(null, currentDate, currentDate, '', '', '', true, this.state.completed, this.state.dropOff, this.state.pickups).then((resp: ApiResponse<Array<OrderDashboard>>) => {

      const pos: Array<OrderDashboard> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (pos) {
        this.setState({ pos });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  loadQueue = (): void => {
    queueRemote.getQueue('check_in').then((resp: ApiResponse<ResultDriverQueue>) => {

      const result: ResultDriverQueue | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (result) {
        this.setState({ queue: result.queue, serving: result.serving, waitTime: result.wait_time });
      }
      
      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return height;
  }


  subscribeToQueue = (): void => {
    const queue = new EventSource(baseUrl+`queue?ghaId=${this.props.user.gha_id}`, headers)
    queue.onmessage = (event) => {

      const parsedData = JSON.parse(event.data)
      if(parsedData.queue) {
        this.setState({ queue: parsedData.queue, serving: parsedData.serving, waitTime: parsedData.wait_time })
      }

    }

    queue.onerror = (error) => {

      if(error.type === 'error') {

      }

   }
  }


  showCompletedOrders = (): void => {
    const poList = [...this.state.pos];
    const filteredList = poList.filter((po: OrderDashboard) => {  
      if(po.truck_status.fully_delivered) {
        return po.truck_status.fully_delivered === !this.state.completed;
      } else {
        return po;
      }
    });
    this.setState({ pos: filteredList, completed: !this.state.completed }, () => {
      this.loadPickupOrders();
    });
  }

  filterOrdersType = (type: string): void => {
    const poList = [...this.state.pos];
    if(type === 'do') {
      const filteredList = poList.filter((po: OrderDashboard) => {  
        if(po.proc === 'Exp') {
          return po.proc !== 'Exp';
        } else {
          return po;
        }
      });
      this.setState({ pos: filteredList, dropOff: !this.state.dropOff }, () => {
        this.loadPickupOrders();
      }); 
    } else {
      const filteredList = poList.filter((po: OrderDashboard) => {  
        if(po.proc === 'Imp') {
          return po.proc !== 'Imp';
        } else {
          return po;
        }
      });
      this.setState({ pos: filteredList, pickups: !this.state.pickups }, () => {
        this.loadPickupOrders();
      });
    }
 
  }

  handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    let countersSelected = [...this.props.dashboardCounters];
    const value: any = event.target.value;
    let counterData: Array<string> = [];
  
    if (value.includes('selectAll')) {
      // Handle 'Select All' option
      countersSelected = this.props.counters.map((counter) => counter.id);
      counterData = this.props.counters.reduce((acc: any, counter) => {
        if (counter.info && 'airlines' in counter.info) {
          acc.push(...counter.info.airlines);
        } else if (counter.info && 'type' in counter.info) {
          acc.push(counter.info.type );
        }
        return acc;
      }, []);
    } else if (value.includes('deselectAll')) {
      // Handle 'Deselect All' option
      countersSelected = [];
      counterData = [];
    }
     else {
      // Check if 'Select All' is currently selected
      const selectAllIndex = countersSelected.indexOf('selectAll');
  
      if (selectAllIndex !== -1) {
        // If 'Select All' was selected, remove it
        countersSelected.splice(selectAllIndex, 1);
      }
      countersSelected = value;
      counterData = countersSelected.reduce((acc: any, selectedCounterId) => {
        const selectedCounter = this.props.counters.find(counter => counter.id === selectedCounterId);
        if (selectedCounter) {
          if (selectedCounter.info && 'airlines' in selectedCounter.info) {
            acc.push(...selectedCounter.info.airlines);
          } else if (selectedCounter.info && 'type' in selectedCounter.info) {
            acc.push(selectedCounter.info.type );
          }
        }
        return acc;
      }, []);
    }
  
    this.setState({ counterData }, () => {
      this.toggleShowDashboard();
    });
    this.props.setCounters(countersSelected);
  };

  render() {

    const slice = this.state.queue.slice(1, 7);

    return (
      <div className={ ghaDashboardStyles.parent }>
        <GhaDashboard 
          filterOrderType={ this.filterOrdersType }
          queue={ this.state.queue }
          serving={ this.state.serving }
          waitTime={ this.props.driverQueueState.waitTime }
          type='dashboard'
          counters={ this.props.counters }
          handleChange={ this.handleChange }
          countersSelected={ this.props.dashboardCounters }
          counterData={ this.state.counterData }
        />
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    driverQueueState: state.driverQueue,
    counters: state.countersAvailable,
    dashboardCounters: state.counterAirlines,
    gha: state.ghaInfo
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    setCounters: (counters: any[]) => dispatch(setAirlinesAction(counters))

  };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(GhaDashboardContainer);